<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <core-table ref="emailTable" :config="config" hide-upsert title="Email list" @read="showEmail">
        </core-table>
      </v-flex>
    </v-layout>
    <app-email-show-modal v-model="emailModal" :item="item"/>
  </v-container>
</template>

<script>

import config from './config_index.js'

export default {
  data () {
    return { 
      config,
      item: {},
      emailModal: false,
      timer: null,
    }
  },
  created() {
    this.timer = setInterval(this.updateData, 5000);
    config.setApp(this)
  },
  beforeDestroy () {
    clearInterval(this.timer);
  },
  methods: {
    updateData() {
      this.$refs.emailTable.getData(false, false);
    },
    showEmail(item) {
      this.item = item
      this.emailModal = true
    },
    clicked() {
      this.$root.$emit('openSnackbar', {
        message: 'Content copied to clipboard',
        color: 'success'
      })
    }
  }
}
</script>
